import oktaClient from "./oktaClient";
const authHeader = oktaClient.getAuthorizationHeader();

class PosConsoleApi {
  private posLink: string;
  private headers: {
    Authorization: string;
    "Content-Type": string;
  };

  constructor(posLink: string) {
    this.posLink = `${posLink}/integration/console/`;
    this.headers = {
      Authorization: authHeader,
      "Content-Type": "application/json"
    };
  }

  get(path: string): Promise<any> {
    return fetch(`${this.posLink}${path}`, {
      headers: this.headers
    });
  }

  post(path: string, data: {}): Promise<any> {
    return fetch(`${this.posLink}${path}`, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(data)
    });
  }

  postMultipart(path: string, data: {}): Promise<any> {
    var formData = new FormData();
    for (let key of Object.keys(data)) {
      let value = data[key];
      formData.append(key, value);
    }

    return fetch(`${this.posLink}${path}`, {
      method: "POST",
      headers: {
        Authorization: authHeader
      },
      body: formData
    });
  }
}

const restApi = new PosConsoleApi(
  `${process.env[`REACT_APP_${process.env.REACT_APP_ENV}_LINK`]}`
);

export default restApi;
